import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PageWrapperProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}

export default function PageWrapper({
  title,
  subtitle,
  actions,
  children,
  className,
}: PageWrapperProps) {
  return (
    <div className={cn('mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8', className)}>
      {/* Page header */}
      <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-2xl font-bold tracking-tight text-foreground">
            {title}
          </h2>
          {subtitle && (
            <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>
          )}
        </div>
        {actions && (
          <div className="flex shrink-0 items-center gap-2">{actions}</div>
        )}
      </div>

      {/* Page content */}
      {children}
    </div>
  );
}
